import { z } from 'zod';

import { AI_MODEL_PLATFORM, MODEL_TYPE } from './constants';

export const zodFilteredModelsQueryParametersSchema = z.object({
  filterType: z.enum(MODEL_TYPE).prefault('all'),
  forceRefresh: z.boolean().optional().prefault(false),
  platform: z.preprocess((value) => {
    if (value === 'di') {
      return 'di';
    }

    if (value === 'ai_foundry') {
      return 'ai_foundry';
    }

    return 'all';
  }, z.enum(AI_MODEL_PLATFORM).optional().prefault('all')),
});
